const whitespace = 'a';
const textfill = (num: number): string => {
    num = Math.floor(num * 0.5 * Math.random() + num);
    return new Array(num).fill(whitespace).join('|');
};
export default textfill;
